const base = 'https://youyan.woledo.com/api/';
//const base = 'http://127.0.0.1:8081/';
var rightheight = 0;
var bodyHeight = 0;

export default {
  base
}